import NaptimeResource from './NaptimeResource';

class Assets extends NaptimeResource {
  static RESOURCE_NAME = 'assets.v1';
}

export default Assets;
